import React, { Component } from 'react';
import FilterBasic from '../../basicElement/FilterBasic';
import moment from 'moment';

const disabledDate = (current, maxMonth) => {
    return current && current.valueOf() > moment(maxMonth).valueOf();
}

class Filter extends Component {
    handleChange = (params, key) => {
        if (key === 'lineOfBusiness') {
            params.secondLineName = undefined;
            this.props.onChange(params, key);
        } else {
            this.props.onChange(params, key);
        }
    }

    render() {
        const { maxMonth, params, stageOption, businessList, ...rest } = this.props;
        const { lineOfBusiness } = params;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const secondLineOption = [...secondLineSet].map(i => ({ value: i, label: i }));
        const filters = [{
            name: '时间',
            key: 'begin',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
                disabledDate: (current) => disabledDate(current, maxMonth)
            }
        }, {
            name: '至',
            key: 'end',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
                disabledDate: (current) => disabledDate(current, maxMonth)
            }
        }, {
            name: '临床项目',
            key: 'keyWord',
            type: 'input',
            typeProperty: {
                style: { width: 165 },
                placeholder: '请输入项目编号或项目简称',
            }
        }, {
            name: '项目阶段',
            key: 'stageIds',
            type: 'select',
            typeProperty: {
                style: { width: 140 },
                mode: 'multiple',
                list: stageOption,
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }, {
            name: '执行业务线二级分类',
            key: 'secondLineName',
            type: 'select',
            typeProperty: {
                disabled: !lineOfBusiness,
                list: secondLineOption,
            }
        }];
        return (
            <FilterBasic filters={filters} params={params} {...rest} onChange={this.handleChange} />
        );
    }
};

export default Filter;


// WEBPACK FOOTER //
// ./src/components/manHour/unconfirmProManhour/Filter.js